import { createApp, onMounted } from 'vue';
import lazyPlugin from 'vue3-lazy'

import initHeader from '../../config'
import { isMobile } from '../../utils/info'

import './index.scss';


const App = {
  setup() {
      onMounted(function () {
          initHeader().init()
      })
      
      return {
          isMobile
      }
  }
}

createApp(App)
  .use(lazyPlugin, {})
  .mount('#app')